import { useSortable } from '@dnd-kit/sortable';
import { useMemo } from 'react';

import { type ConfigViewOption } from '~/store/configViews/types';
import { getSortableItemStyles, visibleHeader } from '~/utils/configurableViewFieldsUtils';

export type ViewVisibilityHeaderProps = {
  option: ConfigViewOption;
  onClick: (nextIsFieldVisible: boolean) => void;
};

const ViewVisibilityHeader = ({ option, onClick }: ViewVisibilityHeaderProps) => {
  const sortableProps = useSortable({
    id: option.derivedId,
    disabled: true,
  });

  const style = useMemo(() => getSortableItemStyles(sortableProps), [sortableProps]);

  return (
    <div
      className="flex cursor-default flex-col"
      // biome-ignore lint/suspicious/noUnnecessaryConditions: PLA-1724 — pre-existing debt, not introduced by the color pairing
      ref={sortableProps?.setNodeRef}
      style={style}
      // biome-ignore lint/suspicious/noUnnecessaryConditions: PLA-1724 — pre-existing debt, not introduced by the color pairing
      {...sortableProps?.attributes}
      data-no-dnd
    >
      <div className="flex items-center justify-between px-1.5 py-2 font-medium ads:text-metadata text-12 text-gray-9 leading-[18px]">
        <span>{option.label}</span>
        <button
          className="cursor-pointer ads:text-secondary text-gray-11"
          // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the color pairing
          onClick={() => onClick(option.derivedId !== visibleHeader.derivedId)}
          type="button"
        >
          {option.derivedId === visibleHeader.derivedId ? 'Hide all' : 'Show all'}
        </button>
      </div>
    </div>
  );
};

ViewVisibilityHeader.displayName = 'ViewVisibilityHeader';

export default ViewVisibilityHeader;
